import { ColorEnum } from '@/constants/color'
import BellIcon from '@/features/notifications/components/NotificationCenter/parts/ToggleButton/parts/BellIcon'
import CountBadge from '@/features/notifications/components/NotificationCenter/parts/ToggleButton/parts/CountBadge'
import { ButtonStateEnum } from '@/features/ui/buttons/constants'
import { useEnabledButtonState } from '@/features/ui/buttons/hooks/useEnabledButtonState'
import { isInteractiveButtonState } from '@/features/ui/buttons/utils'
import { FC, RefObject, memo } from 'react'
import { Pressable, StyleProp, View, ViewStyle } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface ToggleButtonProps {
    active: boolean
    count: number
    onPress: () => void
    style?: StyleProp<ViewStyle>
    ref: RefObject<View | null>
}

const ToggleButton: FC<ToggleButtonProps> = ({ active, count, onPress, style, ref }) => {
    const { state, eventHandlers } = useEnabledButtonState()

    const { styles } = useStyles(stylesheet, {
        active,
        state: isInteractiveButtonState(state) ? state : undefined,
    })

    return (
        <Pressable onPress={onPress} {...eventHandlers} style={[styles.container, style]} ref={ref}>
            <BellIcon color={styles.bellIcon.color} />
            <CountBadge active={active} count={count} />
        </Pressable>
    )
}

const stylesheet = createStyleSheet({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 8,
        height: 32,
        width: 48,
        variants: {
            active: {
                true: {
                    backgroundColor: ColorEnum.YELLOW_500,
                },
                false: {
                    backgroundColor: ColorEnum.Transparent,
                },
            },
            state: {
                [ButtonStateEnum.Hovered]: {
                    opacity: 0.8,
                },
                [ButtonStateEnum.Pressed]: {
                    opacity: 0.6,
                },
            },
        },
    },
    bellIcon: {
        variants: {
            active: {
                true: {
                    color: ColorEnum.BRICK_600,
                },
                false: {
                    color: ColorEnum.WHITE,
                },
            },
        },
    },
})

export default memo(ToggleButton)
